import { StorageGet, UseCase } from '@mdd/api';

export class GetLastLogin implements UseCase<void, number> {
    private storageGet = new StorageGet<number>();

    execute(): number {
        return this.storageGet.execute('lastLogin')!;
    }
}
